import React from 'react';
import './MyBank.component.scss';
import {
  NavbarComponent,
  NavigationMenuComponent,
} from '../../organisms/organisms.index';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { TBankKeys, EBankKeys } from '../../../domain/bank.interface';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { ERoutes } from '../../../assets/constants/routes';
import { ItemListComponent } from '../../atoms/atoms.index';
import { EItemList } from '../../atoms/itemList/ItemList.component';

interface IMyBankLink {
  label: TBankKeys;
  link: string;
  icon: IconName;
}

function MyBankLink(props: IMyBankLink) {
  const { label, link, icon } = props;

  return (
    <div className='my-bank-link-wrapper'>
      <Link to={link}>
        <FormattedMessage id={`pages.my-bank.main.link_${label}`}>
          {(txt: any) => (
            <ItemListComponent
              name={txt}
              type={EItemList.OTHER}
              icon={icon}
              buttons={[{ icon: 'chevron-right' }]}
            />
          )}
        </FormattedMessage>
      </Link>
    </div>
  );
}

export function MyBankComponent(props: any) {
  const myBankLinksConfig: IMyBankLink[] = [
    {
      label: EBankKeys.paymentsResume,
      link: ERoutes.PAYMENTS_RESUME,
      icon: 'file-invoice-dollar',
    },
    {
      label: EBankKeys.pendingPayments,
      link: ERoutes.PENDING_PAYMENTS,
      icon: 'credit-card',
    },
    {
      label: EBankKeys.socialProjects,
      link: ERoutes.SOCIAL_PROJECTS,
      icon: 'globe-europe',
    },
  ];

  return (
    <div className='page-container'>
      <NavbarComponent />
      <NavigationMenuComponent {...props} />
      <div className='content-wrapper'>
        <ul>
          {myBankLinksConfig.map((link: IMyBankLink, idx: number) => (
            <MyBankLink key={idx} {...link} />
          ))}
        </ul>
      </div>
    </div>
  );
}
